import { useCallback } from "react";
import { feedbackApi, SaveResponse, Feedback } from "../../../api";
import { AppType } from "../../../api/models";

/**
 * Custom hook for feedback-related API operations
 */
export const useFeedbackAPI = () => {
    /**
     * Submits user feedback for a conversation
     */
    const submitFeedback = useCallback(async (feedback: Feedback, conv_id: string, appTypeValue: AppType, setError: (error: unknown) => void) => {
        try {
            const request: SaveResponse = {
                feedbacks: feedback
            };

            const response = await feedbackApi(request, conv_id, appTypeValue);

            if (!response.body) {
                throw Error("No response body");
            }
        } catch (e) {
            setError(e);
            console.error("Error submitting feedback:", e);
        }
    }, []);

    return {
        submitFeedback
    };
};
